import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {CssBaseline, ThemeProvider} from "@mui/material";
import {theme} from './theme';
import {initializeApp} from "firebase/app";
import {connectFunctionsEmulator, getFunctions} from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAeyLL_x12V6dKaGyRKBoIiwasvAWYE4Yg",
    authDomain: "personallly.firebaseapp.com",
    projectId: "personallly",
    storageBucket: "personallly.firebasestorage.app",
    messagingSenderId: "1072619066668",
    appId: "1:1072619066668:web:4cc10f750334687b614889"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// initialise emulators
if (window.location.hostname === "localhost") {
    const functions = getFunctions(app);
    connectFunctionsEmulator(functions, "localhost", 5001);
}

export const AppContext = createContext(app);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <AppContext value={app}>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <App/>
            </ThemeProvider>
        </AppContext>
    </React.StrictMode>
);